import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: "cms-grid-entries",
  name: "宫格入口",
  icon: "宫",
  group: "CMS通用",
  description: "展示 CMS 快捷入口宫格。",
  defaultProps: {
    "columns": 4
}
}
